import { ca } from '@cian/analytics';

export const trackBlockShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'card',
    action: 'show',
    label: 'cian_assistant',
  });
};
